import { types } from 'mobx-state-tree';
import FormField from './FormField';

const CustomFormField = types.compose(
  FormField
).named("CustomFormField");

export default CustomFormField;
